import { Injectable } from '@angular/core';
import { EventCodes, FireBaseObjectNames} from '../core/codes';
import { Events } from 'ionic-angular';
import 'rxjs/add/operator/take';
import { AngularFireDatabaseWrapper } from '../providers/angularfire-wrapper';


@Injectable()
export class Navigation {
	public top: any = {};
	public bottom: any = {};
	public more: any = {};
	public fullTop: any = {};
	public fullTopCustom: any = {};
	public fullBottom: any = {};
	public fullBottomCustom: any = {};
	public fullExtra: any = {};

	constructor(
    	private events: Events, 
		public afw: AngularFireDatabaseWrapper 
		){
	}

	public load(){
		this.getData('top').subscribe();
		this.getData('bottom').subscribe();
		this.getData('more').subscribe();
		this.getData('full-top').subscribe();
		this.getData('full-top-custom').subscribe();
		this.getData('full-bottom').subscribe();
		this.getData('full-bottom-custom').subscribe();
		this.getData('full-extra').subscribe();
	}

	public getData(name){
		let self = this;
		let strgRef = '/' + FireBaseObjectNames.NAVIGATION + '/' + name ;
		return self.afw.object(strgRef, undefined, true).map(val=>{
			self.populateData(name, val);
			return val;
		});
	}
	private populateData(name, data){
		if(name == 'top'){
			this.top = data;
		}else if(name == 'bottom'){
			this.bottom = data;
		}else if(name == 'more'){
			this.more = data;
		}else if(name == 'full-top'){
			this.fullTop = data;
		}else if(name == 'full-top-custom'){
			this.fullTopCustom = data;
		}else if(name == 'full-bottom'){
			this.fullBottom = data;
		}else if(name == 'full-bottom-custom'){
			this.fullBottomCustom = data;
		}else if(name == 'full-extra'){
			this.fullExtra = data;
		}
		this.events.publish(EventCodes.NAVIGATION_LOADED, {name: name});
	}
}


// WEBPACK FOOTER //
// ./src/core/navigation.ts